export const MAILING = {
  GET_MAILINGS: 'GET_MAILINGS',
  GET_MAILINGS_SUCCESS: 'GET_MAILINGS_SUCCESS',
  GET_MAILINGS_FAIL: 'GET_MAILINGS_FAIL',
  SET_MAILING_POPUP_DATA: 'SET_MAILING_POPUP_DATA',
  ADD_MAILING: 'ADD_MAILING',
  EDIT_MAILING: 'EDIT_MAILING'
};
